import styled from 'styled-components';

export const Table = styled.div`
  .box-table {
    max-height: 40vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .table-header {
    background: ${(props) => props.theme.$gray200};
    color: ${(props) => props.theme.$gray700};
  }
  .table-text {
    font-size: 12px;
    color: ${(props) => props.theme.$gray600};
  }
  .table-row:hover {
    background: ${(props) => props.theme.$gray100};
  }
`;
